exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes change-color {\n  0% {\n    border: solid 2px #086670;\n  }\n  100% {\n    border: solid 2px #fdfdfd;\n  }\n}\n@-moz-keyframes change-color {\n  0% {\n    border: solid 2px #086670;\n  }\n  100% {\n    border: solid 2px #fdfdfd;\n  }\n}\n@keyframes change-color {\n  0% {\n    border: solid 2px #086670;\n  }\n  100% {\n    border: solid 2px #fdfdfd;\n  }\n}\n@-webkit-keyframes animate-add-service-button {\n  0% {\n    margin-right: 0px;\n  }\n  100% {\n    margin-right: calc(100% - 194px);\n  }\n}\n@-moz-keyframes animate-add-service-button {\n  0% {\n    margin-right: 0px;\n  }\n  100% {\n    margin-right: calc(100% - 194px);\n  }\n}\n@keyframes animate-add-service-button {\n  0% {\n    margin-right: 0px;\n  }\n  100% {\n    margin-right: calc(100% - 194px);\n  }\n}\n\n.circle-loader, .circle-loader-white, .circle-loader-green, .circle-loader-black {\n  position: absolute;\n  left: 0;\n  font-size: 2px;\n  border-radius: 50%;\n  animation-name: loader-spin;\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  display: inline-block;\n  vertical-align: top;\n}\n\n@keyframes loader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.circle-loader-black {\n  border-left: 2px solid #1e1c1e;\n  border-top: 2px solid #1e1c1e;\n  border-right: 2px solid #1e1c1e;\n  border-bottom: 2px solid transparent;\n  margin: 0px 0 2px 2px;\n  width: 6em;\n  height: 6em;\n}\n\n.circle-loader-green {\n  margin: 2px 0 0px 2px;\n  border-left: 2px solid #fdfdfd;\n  border-top: 2px solid #fdfdfd;\n  border-right: 2px solid #fdfdfd;\n  border-bottom: 2px solid transparent;\n  background-color: #086670;\n  z-index: 2;\n  width: 8em;\n  height: 8em;\n}\n\n.circle-loader-white {\n  margin: 2px 0 0px 2px;\n  border-left: 2px solid #086670;\n  border-top: 2px solid #086670;\n  border-right: 2px solid #086670;\n  border-bottom: 2px solid transparent;\n  width: 8em;\n  height: 8em;\n}\n\n.offline {\n  margin: 20px;\n  margin-top: 60px;\n  text-align: center;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n}", ""]);

// exports
exports.locals = {
	"backgroundFadedGreen": "#d0dedf",
	"backgroundGray": "#F2F2F2",
	"blackPrimary": "#1e1c1e",
	"blackSecondary": "#000000",
	"buttonRed": "#f41c50",
	"darkStormyGray": "#444242",
	"errorRed": "#BF1000",
	"feedbackBlack": "#1d1b1d",
	"feedbackDarkestGray": "#221f1f",
	"feedbackDarkerGray": "#231f20",
	"feedbackBlue": "#7fdae4",
	"feedbackDarkGray": "#363335",
	"feedbackGreen": "#7dab7e",
	"feedbackPurple": "#a0025a",
	"grayButton": "#777777",
	"grayHeading": "#f4f4f4",
	"grayPrimary": "#e8e8e8",
	"iconBlue": "#086670",
	"lightGrayButton": "#e9e8e7",
	"opacityWhiteLight": "rgba(255, 255, 255, 0.9)",
	"redRemove": "#e91145",
	"samGreen": "#1e851e",
	"samOrange": "#f5a623",
	"samRed": "#e81418",
	"samGray": "#777777",
	"turquoiseBlue": "#008391",
	"warningOrange": "#f46200",
	"whitePrimary": "#fdfdfd",
	"whiteSecondary": "#ffffff",
	"yellowOnBlack": "#ffe500",
	"yellowPrimary": "#ffdc00"
};